import axiosClient from '../axiosClient';
import { FastMovingSkuEndpoint } from '../endpoints/fastMovingSku';
import {
  IFastMovingSkuVersionSummary,
  IUploadFastMovingSkuResponse,
} from '../../types/api/response/fastmovingskuresponse';

export const FastMovingSkuService = {
  async uploadCsv(file: File): Promise<IUploadFastMovingSkuResponse> {
    const formData = new FormData();
    formData.append('file', file);
    const res = await axiosClient.post<IUploadFastMovingSkuResponse>(
      FastMovingSkuEndpoint.UPLOAD_FAST_MOVING_SKU,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    return res.data;
  },
  async activateVersion(listVersion: number): Promise<IUploadFastMovingSkuResponse> {
    const url = FastMovingSkuEndpoint.ACTIVATE_FAST_MOVING_SKU.replace(
      ':version',
      String(listVersion),
    );
    const res = await axiosClient.post<IUploadFastMovingSkuResponse>(url);
    return res.data;
  },
  async listVersions(): Promise<IFastMovingSkuVersionSummary[]> {
    const res = await axiosClient.get<IFastMovingSkuVersionSummary[]>(
      FastMovingSkuEndpoint.LIST_FAST_MOVING_SKU_VERSIONS,
    );
    return res.data;
  },
};
